export const ROLE_GUARD_KEYS = {
  ROLES: 'roles',
} as const;
